import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-drawer background-fb" }
const _hoisted_2 = { class: "card-header header-drawer d-flex flex-row align-items-center justify-content-between" }
const _hoisted_3 = { class: "card-body overflow-auto font-size-14" }
const _hoisted_4 = { class: "d-flex flex-row align-items-center justify-content-between" }
const _hoisted_5 = { class: "d-flex flex-row align-items-center gap-2" }

import { onBeforeMount, ref } from "vue";
import { ElInputNumber, ElTooltip } from "element-plus";
import { cloneDeep } from "lodash-es";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditDelay',
  props: {
    name: {},
    existingDelay: {}
  },
  emits: ["close", "change"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const emit = __emit;

const props = __props;

const delay = ref(0);

onBeforeMount(() => {
  if (props.existingDelay) {
    delay.value = cloneDeep(props.existingDelay);
  }
});

function removeDelay() {
  emit("change", undefined);
  emit("close");
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(t)("Common.DelaySettings")) + " - " + _toDisplayString(_ctx.name) + " ", 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        id: "filter-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "times" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(t)("Common.DelayDescription")) + "  ", 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(ElInputNumber), {
            modelValue: delay.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((delay).value = $event)),
            class: "width-100",
            min: 0,
            step: 100,
            size: "small",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (emit('change', delay.value)))
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(ElTooltip), {
            effect: "custom",
            placement: "top",
            content: _unref(t)('Common.RemoveDelay')
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn btn-link",
                type: "button",
                onClick: removeDelay
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "trash" })
              ])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ])
  ]))
}
}

})